import * as React from 'react';

import Video16 from './Video16';

export const video16 = () => <Video16 />;

export default {
    title: 'Icon/Line/Video16',
    component: Video16,
    parameters: {
        notes: "`import Video16 from 'box-ui-elements/es/icon/line/Video16';`",
    },
};
